import httpClient from '../../shared/services/httpClient';

export const SearchEstabilishment = async () => {
  return await httpClient.get(`/estabilishmenttype/all`, { skipAuth: true });
};
